// extracted by css-extract-rspack-plugin
export default {"wrapper":"CategoryClassPicker_wrapper__1f-TR","secondaryItemLabel":"CategoryClassPicker_secondaryItemLabel__6R1YK","treeWrapper":"CategoryClassPicker_treeWrapper__6BEvJ"};